import { env } from "@saas/config/shared";
import { isDev, isTest } from "@saas/shared/utils/environment/environment";

export type TCreateLoyaltyUrlInput = {
  brandSlug: string;
  pathname?: string;
};

export type TCreateLoyaltyUrlOutput = string;

/**
 * @description
 * Create loyalty url based on the brand and pathname. This function will return the loyalty url based on the environment.
 * Only `dev` environment will have the brand as the path.
 *
 * @description `local`/`test` - http://${brand}.${LOYALTY_URL}${pathname}
 * @description `dev` - https://${LOYALTY_URL}/${brand}${pathname}
 * @description `default` - https://${brand}.${LOYALTY_URL}${pathname}
 */
export const createLoyaltyUrl = ({
  brandSlug,
  pathname = "",
}: TCreateLoyaltyUrlInput): TCreateLoyaltyUrlOutput => {
  let url = env.LOYALTY_URL;

  if (isDev || isTest) {
    url = url.replace("http://", `http://${brandSlug}.`);

    return url + pathname;
  }

  if (env.APP_ENV === "dev") {
    let hostname = `${brandSlug}.${env.LOYALTY_URL}`;
    hostname = hostname.replace("https://", "");
    url = `${url}/${hostname}`;

    return url + pathname;
  }

  url = url.replace("https://", `https://${brandSlug}.`);

  return url + pathname;
};
